import React from "react";
import EContentView from "./view/_content";
import { contentsService } from "./model/service";
import { useTranslation } from "react-i18next";
function EContent({scrollTo}){
    return <>
        <EContentView getContentsApi={contentsService.getContentData} scrollTo={scrollTo}/>
    </>
}  
export default EContent;